import { render, staticRenderFns } from "./Newdisk.vue?vue&type=template&id=1530c56a&scoped=true&"
import script from "./Newdisk.vue?vue&type=script&lang=js&"
export * from "./Newdisk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1530c56a",
  null
  
)

export default component.exports